<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.applicantAccountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="acceptanceDepositDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>
          <v-col v-if="acceptanceDepositDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.acceptanceDepositDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.acceptanceDepositDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { AcceptanceDepositStep } from '@/constants';

export default {
  name: 'ApplicantBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    BankDetails,
    Footer,
  },
  data: () => ({
    StepDirection,
    StepName,
    leaveStep,
    Text,
    getValidationErrorText,
    invalidFields: [],
    applicantAccountBankDetails: { ...bankDetails },
    acceptanceDepositDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      applicantAccountBankDetails: bankDetailsValidation,
      acceptanceDepositDetails: {
        note: {
          required: requiredIf(
            () => this.acceptanceDepositDetails.hasPrivilege
          ),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SAABD = ServicesModule.statement.applicantAccountBankDetails;
      const SADD = ServicesModule.statement.acceptanceDepositDetails;

      if (SAABD) {
        this.applicantAccountBankDetails = {
          ...this.applicantAccountBankDetails,
          ...SAABD,
        };
      }

      if (SADD) {
        this.acceptanceDepositDetails = {
          ...this.acceptanceDepositDetails,
          ...SADD,
        };
      }
    },

    assemblyModel() {
      if (!this.acceptanceDepositDetails.hasPrivilege) {
        this.acceptanceDepositDetails.note = null;
      }

      return {
        applicantAccountBankDetails: {
          ...this.applicantAccountBankDetails,
        },
        acceptanceDepositDetails: {
          ...this.acceptanceDepositDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: AcceptanceDepositStep.APPLICANT_BANK_DETAILS,
      });
    },
  },
};
</script>
